import React from 'react'
import { withRouter } from 'react-router-dom'

const ICONS = {
    clients: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5 12 3l9 4.5M5.25 8.625V18a.75.75 0 0 0 .75.75H9v-5.25h6v5.25h3a.75.75 0 0 0 .75-.75V8.625" />
        </svg>
    ),
    events: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 3.75v2.5M17 3.75v2.5M4.75 8.25h14.5M6.5 5.25h11A1.75 1.75 0 0 1 19.25 7v10.5a1.75 1.75 0 0 1-1.75 1.75h-11a1.75 1.75 0 0 1-1.75-1.75V7A1.75 1.75 0 0 1 6.5 5.25Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.5 12h3M8.5 15.25h5.75" />
        </svg>
    ),
    assets: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 7.5A2.25 2.25 0 0 1 6.75 5.25h10.5A2.25 2.25 0 0 1 19.5 7.5v9A2.25 2.25 0 0 1 17.25 18.75H6.75A2.25 2.25 0 0 1 4.5 16.5v-9Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 13.5 1.875-1.875a1.125 1.125 0 0 1 1.59 0l1.785 1.785a1.125 1.125 0 0 0 1.59 0L17.25 11.25" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 8.625h.008v.008h-.008z" />
        </svg>
    ),
    sun: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
            <circle cx="12" cy="12" r="4" />
            <path strokeLinecap="round" d="M12 2.75v2.5M12 18.75v2.5M21.25 12h-2.5M5.25 12h-2.5M18.54 5.46l-1.77 1.77M7.23 16.77l-1.77 1.77M18.54 18.54l-1.77-1.77M7.23 7.23 5.46 5.46" />
        </svg>
    ),
    moon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12.79A9 9 0 0 1 11.21 3c0 .24-.01.48-.01.72A9 9 0 1 0 20.28 12c.24 0 .48-.01.72-.01Z" />
        </svg>
    ),
    logout: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 7.5V5.625A2.625 2.625 0 0 0 13.125 3h-6.75A2.625 2.625 0 0 0 3.75 5.625v12.75A2.625 2.625 0 0 0 6.375 21h6.75a2.625 2.625 0 0 0 2.625-2.625V16.5" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12H9m0 0 3.75-3.75M9 12l3.75 3.75" />
        </svg>
    )
}

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            theme: this._getCurrentTheme(),
            mobileMenuOpen: false
        }
    }

    componentDidMount() {
        this._applyTheme(this.state.theme)
    }

    _getCurrentTheme() {
        if (typeof document === 'undefined') return 'dark'
        if (document.documentElement.classList.contains('dark')) return 'dark'
        return document.documentElement.getAttribute('data-theme') || 'light'
    }

    _applyTheme(theme) {
        if (typeof document === 'undefined') return
        document.documentElement.classList.toggle('dark', theme === 'dark')
        document.documentElement.setAttribute('data-theme', theme)
        window.localStorage.setItem('s50-admin-theme', theme)
    }

    _toggleTheme() {
        const theme = this.state.theme === 'dark' ? 'light' : 'dark'
        this.setState({ theme }, () => this._applyTheme(theme))
    }

    _displayName() {
        const user = this.props.user || {}
        return user.name || user.given_name || user.email || 'Admin user'
    }

    _userInitial() {
        return String(this._displayName()).trim().charAt(0).toUpperCase() || 'A'
    }

    render() {
        const pathname = this.props.location ? this.props.location.pathname : ''
        const links = [
            { href: '/clients', label: 'Clients', description: 'Client workspace', icon: ICONS.clients, match: pathname.indexOf('/clients') === 0 },
            { href: '/events', label: 'Events', description: 'Live and recent', icon: ICONS.events, match: pathname.indexOf('/events') === 0 },
            { href: '/assets', label: 'Assets', description: 'Shared library', icon: ICONS.assets, match: pathname.indexOf('/assets') === 0 }
        ]
        const isDark = this.state.theme === 'dark'

        return (
            <React.Fragment>
                <div className="border-b border-slate-200/70 bg-white/80 backdrop-blur dark:border-slate-800 dark:bg-slate-950/80 lg:hidden">
                    <div className="flex items-center justify-between px-4 py-4 sm:px-6">
                        <a href="/clients" className="flex items-center gap-3 rounded-2xl bg-white px-3 py-2 no-underline shadow-sm dark:bg-slate-900">
                            <img src="/images/qr-logo.png" alt="Split 50-50" className="h-9 w-9" />
                            <span className="text-lg font-extrabold tracking-tight text-slate-900 dark:text-white">Split 50-50</span>
                        </a>
                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => this.setState((state) => ({ mobileMenuOpen: !state.mobileMenuOpen }))}
                                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-sky-300 hover:text-sky-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:text-white"
                                aria-label="Toggle navigation"
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-5 w-5">
                                    {this.state.mobileMenuOpen ?
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6 6 18" />
                                        :
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 7h15M4.5 12h15M4.5 17h15" />}
                                </svg>
                            </button>
                            <button
                                onClick={() => this._toggleTheme()}
                                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-sky-300 hover:text-sky-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:text-white"
                            >
                                {isDark ? ICONS.sun : ICONS.moon}
                            </button>
                            {this.props.user ?
                                <button
                                    onClick={() => this.props.logout()}
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-rose-300 hover:text-rose-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:text-white"
                                >
                                    {ICONS.logout}
                                </button>
                                : null}
                        </div>
                    </div>
                    {this.state.mobileMenuOpen ?
                        <nav className="grid gap-2 px-4 pb-4 sm:px-6">
                            {links.map((link) => (
                                <a
                                    key={link.href}
                                    href={link.href}
                                    className={
                                        'flex items-center gap-3 rounded-2xl border px-4 py-3 no-underline transition ' +
                                        (link.match
                                            ? 'border-slate-900 bg-slate-900 text-white dark:border-sky-500 dark:bg-sky-500 dark:text-slate-950'
                                            : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:text-sky-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:text-white')
                                    }
                                >
                                    <span className={link.match ? 'text-sky-300 dark:text-slate-950' : 'text-slate-400'}>
                                        {link.icon}
                                    </span>
                                    <span className="min-w-0">
                                        <span className="block text-sm font-semibold">{link.label}</span>
                                        <span className={'block text-xs ' + (link.match ? 'text-slate-300 dark:text-slate-800' : 'text-slate-400 dark:text-slate-500')}>{link.description}</span>
                                    </span>
                                </a>
                            ))}
                        </nav>
                        : null}
                </div>

                <aside className="hidden w-80 shrink-0 lg:flex lg:min-h-screen lg:flex-col lg:border-r lg:border-slate-200/70 lg:bg-white/80 lg:px-6 lg:py-6 lg:backdrop-blur dark:lg:border-slate-800 dark:lg:bg-slate-950/70">
                    <div className="flex items-center justify-between">
                        <a href="/clients" className="inline-flex items-center gap-3 rounded-2xl bg-white px-3 py-2 no-underline shadow-sm dark:bg-slate-900">
                            <img src="/images/qr-logo.png" alt="Split 50-50" className="h-10 w-10" />
                            <span className="text-xl font-extrabold tracking-tight text-slate-900 dark:text-white">Split 50-50</span>
                        </a>
                        <button
                            onClick={() => this._toggleTheme()}
                            className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-sky-300 hover:text-sky-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:text-white"
                        >
                            {isDark ? ICONS.sun : ICONS.moon}
                        </button>
                    </div>

                    <div className="mt-10">
                        <div className="px-3 text-xs font-semibold uppercase tracking-[0.28em] text-slate-400 dark:text-slate-500">
                            Navigation
                        </div>
                        <nav className="mt-4 space-y-2">
                            {links.map((link) => (
                                <a
                                    key={link.href}
                                    href={link.href}
                                    className={
                                        'group flex items-center gap-3 rounded-2xl px-4 py-3 no-underline transition ' +
                                        (link.match
                                            ? 'bg-slate-900 text-white shadow-lg shadow-slate-900/10 dark:bg-slate-800'
                                            : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-900 dark:hover:text-white')
                                    }
                                >
                                    <span className={link.match ? 'text-sky-300' : 'text-slate-400 group-hover:text-sky-500 dark:group-hover:text-sky-300'}>
                                        {link.icon}
                                    </span>
                                    <span className="min-w-0">
                                        <span className="block text-sm font-semibold">{link.label}</span>
                                        <span className={'block text-xs ' + (link.match ? 'text-slate-300' : 'text-slate-400 dark:text-slate-500')}>{link.description}</span>
                                    </span>
                                </a>
                            ))}
                        </nav>
                    </div>

                    <div className="mt-auto rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
                        <div className="flex items-center gap-3">
                            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-100 text-sm font-bold text-sky-700 dark:bg-sky-500/10 dark:text-sky-300">
                                {this._userInitial()}
                            </div>
                            <div className="min-w-0 flex-1">
                                <div className="truncate text-sm font-semibold text-slate-900 dark:text-white">{this._displayName()}</div>
                                <div className="truncate text-xs text-slate-500 dark:text-slate-400">{this.props.user && this.props.user.email ? this.props.user.email : 'Authenticated session'}</div>
                            </div>
                            {this.props.user ?
                                <button
                                    onClick={() => this.props.logout()}
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 transition hover:border-rose-300 hover:text-rose-600 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:text-white"
                                >
                                    {ICONS.logout}
                                </button>
                                : null}
                        </div>
                    </div>
                </aside>
            </React.Fragment>
        )
    }
}

export default withRouter(Header)
